import { render, staticRenderFns } from "./ProductionUnitList.vue?vue&type=template&id=0452c660&scoped=true"
import script from "./ProductionUnitList.vue?vue&type=script&lang=js"
export * from "./ProductionUnitList.vue?vue&type=script&lang=js"
import style0 from "./ProductionUnitList.vue?vue&type=style&index=0&id=0452c660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452c660",
  null
  
)

export default component.exports